export default "__VITE_ASSET__Dt$nxjyk__"